import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { View } from 'foundations-components/components/View';
import { MerchCardColumns } from 'pricing-pages-ui-components/components/MerchCardColumns';
import { BaseCardBadge } from '../../components/merch-card/BaseCardBadge';
import { SCREENS } from '../../constants/tracking/Screens';
import { HubMerchCard } from '../../containers/merch-card/cards/HubMerchCard';
import { CustomerPlatformFeaturesContainer } from '../../containers/merch-card/features-display/customer-platform/CustomerPlatformFeaturesContainer';
import { MerchCardTitleContainer } from '../../containers/merch-card/headings-display/MerchCardTitleContainer';
import { useBadges } from '../../hooks/badges/useBadges';
import { isValidApiName } from '../../utils/typeguards';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const CustomerPlatformMerchCards = () => {
  var _badges$starterApiNam, _badges$professionalA, _badges$enterpriseApi;
  const screen = SCREENS.SUITE;
  const starterApiName = 'crm-suite-starter-bundle';
  const professionalApiName = 'crm-suite-professional-bundle';
  const enterpriseApiName = 'crm-suite-enterprise-bundle';
  const productApiNames = [starterApiName, professionalApiName, enterpriseApiName].filter(isValidApiName);
  const {
    badges,
    hasBadgeOnFirstColumn,
    hasBadgeOnLastColumn
  } = useBadges({
    productApiNames
  });
  return /*#__PURE__*/_jsx(View, {
    position: "relative",
    marginBlockEnd: "800",
    children: /*#__PURE__*/_jsxs(MerchCardColumns, {
      columns: 3,
      hasBadgeOnFirstColumn: hasBadgeOnFirstColumn,
      hasBadgeOnLastColumn: hasBadgeOnLastColumn,
      children: [/*#__PURE__*/_jsx(HubMerchCard, {
        apiName: starterApiName,
        columnStart: 1,
        Title: /*#__PURE__*/_jsx(MerchCardTitleContainer, {
          Title: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
            message: "pricing-pages-ui.merchCardsV2.customerPlatform.starterCard.title"
          }),
          Badge: /*#__PURE__*/_jsx(BaseCardBadge, {
            apiName: starterApiName,
            badgeName: badges === null || badges === void 0 || (_badges$starterApiNam = badges[starterApiName]) === null || _badges$starterApiNam === void 0 ? void 0 : _badges$starterApiNam.badgeName
          })
        }),
        Subheading: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "pricing-pages-ui.merchCardsV2.customerPlatform.starterCard.description"
        }),
        Features: /*#__PURE__*/_jsx(CustomerPlatformFeaturesContainer, {
          productLevel: "STARTER",
          productApiName: starterApiName
        }),
        screen: screen
      }, starterApiName), /*#__PURE__*/_jsx(HubMerchCard, {
        apiName: professionalApiName,
        columnStart: 2,
        Title: /*#__PURE__*/_jsx(MerchCardTitleContainer, {
          Title: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
            message: "pricing-pages-ui.merchCardsV2.customerPlatform.professionalCard.title"
          }),
          Badge: /*#__PURE__*/_jsx(BaseCardBadge, {
            apiName: professionalApiName,
            badgeName: badges === null || badges === void 0 || (_badges$professionalA = badges[professionalApiName]) === null || _badges$professionalA === void 0 ? void 0 : _badges$professionalA.badgeName
          })
        }),
        Subheading: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "pricing-pages-ui.merchCardsV2.customerPlatform.professionalCard.description"
        }),
        Features: /*#__PURE__*/_jsx(CustomerPlatformFeaturesContainer, {
          productLevel: "PROFESSIONAL",
          productApiName: professionalApiName
        }),
        screen: screen
      }, professionalApiName), /*#__PURE__*/_jsx(HubMerchCard, {
        apiName: enterpriseApiName,
        columnStart: 3,
        Title: /*#__PURE__*/_jsx(MerchCardTitleContainer, {
          Title: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
            message: "pricing-pages-ui.merchCardsV2.customerPlatform.enterpriseCard.title"
          }),
          Badge: /*#__PURE__*/_jsx(BaseCardBadge, {
            apiName: enterpriseApiName,
            badgeName: badges === null || badges === void 0 || (_badges$enterpriseApi = badges[enterpriseApiName]) === null || _badges$enterpriseApi === void 0 ? void 0 : _badges$enterpriseApi.badgeName
          })
        }),
        Subheading: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "pricing-pages-ui.merchCardsV2.customerPlatform.enterpriseCard.description"
        }),
        Features: /*#__PURE__*/_jsx(CustomerPlatformFeaturesContainer, {
          productLevel: "ENTERPRISE",
          productApiName: enterpriseApiName
        }),
        screen: screen
      }, enterpriseApiName)]
    })
  });
};